import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import { setShowErrorModal } from "../store/slices/preferenceSlice";
import { onSetTxToken } from "../store/slices/preferenceSlice";
import { getUrl } from "../helpers/getUrl";

import hubspotLogo from "../assets/images/hubspotLogo.svg";
import arrowIcon from "../assets/images/icondoublearrows.png";
import tripletexLogo from "../assets/images/tripletexLogo.png";

const RedirectTripletex = () => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [reconnect, setReconnect] = useState(false);
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();

  const { txToken } = useSelector((state) => state.preference);

  const onConnectTripletex = async (token) => {
    try {
      setIsBtnLoading(true);
      const companyId = searchParams.get("companyId");
      const companyName = searchParams.get("companyName");
      const orgNumber = searchParams.get("orgNumber");

      await axios.post(getUrl("REACT_APP_CONNECT_TRIPLETEX"), {
        companyId,
        token,
        companyName,
        orgNumber,
      });
    } catch (error) {
      console.log(error);
      setReconnect(true);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      console.log(errorMessage);
      dispatch(setShowErrorModal({ message: errorMessage }));
    } finally {
      setIsBtnLoading(false);
    }
  };

  const onRedirect = (token) => {
    const companyId = searchParams.get("companyId");
    const companyName = searchParams.get("companyName");
    const orgNumber = searchParams.get("orgNumber");
    window.open(
      `${getUrl(
        "REACT_APP_CONNECT_TRIPLETEX"
      )}?companyId=${companyId}&companyName=${companyName}&orgNumber=${orgNumber}&token=${token}`,
      "_self"
    );
  };

  return (
    <div>
      <Container
        className="tx-connect-container"
        style={{
          minHeight: `${window.location.pathname !== "/setup" && "100vh"}`,
        }}
      >
        <Col
          lg={7}
          className="d-flex flex-column justify-content-center align-items-center h-100"
        >
          <Card className="tx-connect-card my-auto w-75">
            <Card.Body className="tx-card-body d-flex flex-column justify-content-center align-items-center">
              <div className="d-flex flex-column align-items-center my-5 px-4">
                <h4 style={{ fontWeight: "600" }}>
                  Connect Your Tripletex Account to HubSpot
                </h4>

                <p>Welcome to the Tripletex connection page.</p>
                <div className="d-flex flex-row align-items-center my-5">
                  <Card.Img
                    src={tripletexLogo}
                    alt="tripletex logo"
                    bsPrefix="tx-logo"
                    style={{ width: "72px" }}
                  />
                  <Card.Img
                    src={arrowIcon}
                    alt="arrow"
                    bsPrefix="arrow-icon"
                    className="mx-5 my-auto"
                    style={{ width: "30px" }}
                  />
                  <Card.Img
                    src={hubspotLogo}
                    alt="hubspot logo"
                    bsPrefix="hubspot-logo"
                    style={{ width: "72px" }}
                  />
                </div>

                <p>
                  To link your Tripletex account with HubSpot, click the
                  "Connect" button.
                </p>
                <p>
                  If your token is invalid or deactivated, you can manually
                  input a new token to proceed with the connection process.
                </p>

                {!reconnect ? (
                  <div>
                    <Button
                      className="tx-card-button"
                      disabled={isBtnLoading}
                      onClick={() =>
                        onConnectTripletex(searchParams.get("token"))
                      }
                    >
                      {isBtnLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Connect"
                      )}
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div className="d-flex flex-row">
                      <Form.Control
                        type="text"
                        placeholder="enter token"
                        size="sm"
                        onChange={(e) =>
                          dispatch(onSetTxToken({ token: e.target.value }))
                        }
                        value={txToken}
                        style={{
                          width: "75%",
                        }}
                      />
                      <Button
                        className="tx-card-button ms-3"
                        disabled={isBtnLoading}
                        onClick={() => onRedirect(txToken)}
                      >
                        {isBtnLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Connect"
                        )}
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Container>
    </div>
  );
};

export default RedirectTripletex;
